
import { useEffect, useState } from 'react';
import MyDatasets from '../../../actions/MyDatasets';
import MainContent from '../../../components/MainContent';
import Navigation from '../../../components/navigation';
import MenuButton from '../../../components/MenuButton';

import LoginForm from '../../../components/LoginForm';
import { useNavigate } from 'react-router-dom';

import GeneralApi from "../../../services/openapi/api/GeneralApi.js"

function DatasetsPage() {
    const [loginForm, setLoginForm] = useState(false);
    const [user, setUser] = useState(false);
    const navigate = useNavigate();

    const generalApi = new GeneralApi();

    useEffect(() => {

        const navigatorHeight = getComputedStyle(document.body).getPropertyValue('--navigation-max-height').split('px')[0];

        if (document.getElementById("myDatasets") && document.getElementById("RightPage")) {
            document.getElementById("myDatasets").style.height = window.innerHeight / 100 * 7 > 55 ?
                (window.innerHeight - 55 - navigatorHeight) + 'px' :
                (window.innerHeight - (window.innerHeight / 100 * 7) - 10 - navigatorHeight) + 'px';

            document.getElementById("RightPage").style.height = window.innerHeight / 100 * 7 > 55 ?
                (window.innerHeight - 55 - navigatorHeight) + 'px' :
                'calc(93% - var(--navigation-max-height))';
        }

        generalApi.userinfo().then((response) => {
            setUser(response)
        });
    }, [])
    return (<>
        <Navigation
            showLoginForm={() => { setLoginForm(!loginForm); }}
            user={user}
        />
        {loginForm &&
            <LoginForm
                afterLogin={() => {
                    generalApi.userinfo().then((response) => {
                        setUser(response)
                        navigate('/lk/MyDatasets')
                    });
                    setLoginForm(false);
                }}
            />
        }
        <MenuButton />
        <div id="RightPage">
            <MainContent />
            <MyDatasets />
        </div></>
    )
}
export default DatasetsPage